const transObjKey = (obj, keyMap) => {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    // transform array
    if (Array.isArray(obj)) {
        return obj.map(el => transObjKey(el, keyMap));
    }
    // transform object
    Object.keys(obj).forEach(key => {
        if (keyMap[key]) {
            obj[keyMap[key]] = obj[key];
        }
        obj[key] = transObjKey(obj[key], keyMap);
    });
    return obj;
};

export function transformRechargeDetailApi(res) {
    const keyMap = {
        purchaseNotesImg: 'purchase_notes_img',
        payFinishTipsImg: 'pay_finish_tips_img',
        productId: 'product_id',
        specName: 'spec_name',
        unitPrice: 'unit_price',
        unitPriceOld: 'unit_price_old',
        isActivity: 'is_activity',
        activitySkuId: 'activity_sku_id',
        activityVerifyMethod: 'activity_verify_method',
        activityPopupDisplayMethod: 'activity_popup_display_method',
        activityPopupImg: 'activity_popup_img',
        beginTime: 'begin_time',
        endTime: 'end_time',
        channelShow: 'channel_show',
        confirmTips: 'confirm_tips',
        cornerMark: 'corner_mark',
        priceType: 'price_type',
        jumpUrl: 'jump_url',
        partnerId: 'partner_id',
        paymentCycle: 'payment_cycle',
        firstMonthPrice: 'first_month_price',
        otherMonthPrice: 'other_month_price',
        planId: 'plan_id',
        skuNo: 'sku_no',
        channelId: 'channel_id',
        costPrice: 'cost_price',
        renewalPrice: 'renewal_price',
        renewalSwitch: 'renewal_switch',
        releaseCycle: 'release_cycle',
        releaseReasonId: 'release_reason_id',
        isTengxunType: 'is_tengxun_type',
        isVideoType: 'is_video_type',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
        hasSign: 'has_sign',
        signedAccount: 'signed_account',
    };

    return transObjKey(res, keyMap);
}

export function transformActivityVerifyApi(res) {
    const keyMap = {
        usable: 'useable',
        productId: 'product_id',
        channelId: 'channel_id',
        skuNo: 'sku_no',
        jointImg: 'joint_img',
        specName: 'spec_name',
        unitPriceOld: 'unit_price_old',
        unitPrice: 'unit_price',
        costPrice: 'cost_price',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
        beginTime: 'begin_time',
        endTime: 'end_time',
        partnerId: 'partner_id',
        isVideoType: 'is_video_type',
        isTengxunType: 'is_tengxun_type',
        paymentCycle: 'payment_cycle',
        channelShow: 'channel_show',
        planId: 'plan_id',
        releaseCycle: 'release_cycle',
        releaseReasonId: 'release_reason_id',
        firstMonthPrice: 'first_month_price',
        otherMonthPrice: 'other_month_price',
        cornerMark: 'corner_mark',
        confirmTips: 'confirm_tips',
        isActivity: 'is_activity',
        activitySkuId: 'activity_sku_id',
        activityVerifyMethod: 'activity_verify_method',
        activityPopupDisplayMethod: 'activity_popup_display_method',
        activityPopupImg: 'activity_popup_img',
        jumpUrl: 'jump_url',
        renewalSwitch: 'renewal_switch',
        renewalPrice: 'renewal_price',
        userChannelIds: 'user_channel_ids',
        aesKey: 'aes_key',
        standardSkuId: 'standard_sku_id',
        identityType: 'identity_type',
        priceTyp: 'price_type',
    };
    return transObjKey(res, keyMap);
}

export function transformPayFinishApi(res) {
    const keyMap = {
        orderId: 'order_id',
        app: 'is_app',
        buttonContext: 'button_context',
        buttonLink: 'button_link',
        isMaoYan: 'is_maoyan',
        customPhone: 'custom_phone',
        isEmptyShortUrl: 'is_empty_short_url',
        productId: 'product_id',
        payFinishTipsImg: 'pay_finish_tips_img',
    };

    return transObjKey(res, keyMap);
}

export function transformOrderDetailApi(res) {
    const keyMap = {
        orderId: 'order_id',
        unitPrice: 'unit_price',
        totalPrice: 'total_price',
        couponPrice: 'coupon_price',
        payPrice: 'pay_price',
        payAt: 'pay_at',
        productId: 'product_id',
        skuId: 'sku_id',
        payPart: 'pay_part',
        createdAt: 'created_at',
        productName: 'product_name',
        maoyanShortUrl: 'maoyan_short_url',
        showMaoyanUrl: 'show_maoyan_url',
        partnerId: 'partner_id',
        detailUrl: 'detail_url',
        rechargeSku: 'recharge_sku',
        channelId: 'channel_id',
        skuNo: 'sku_no',
        jointImg: 'joint_img',
        specName: 'spec_name',
        unitPriceOld: 'unit_price_old',
        costPrice: 'cost_price',
        updatedAt: 'updated_at',
        beginTime: 'begin_time',
        endTime: 'end_time',
        isVideoType: 'is_video_type',
        isTengxunType: 'is_tengxun_type',
        paymentCycle: 'payment_cycle',
        channelShow: 'channel_show',
        planId: 'plan_id',
        releaseCycle: 'release_cycle',
        releaseReasonId: 'release_reason_id',
        firstMonthPrice: 'first_month_price',
        otherMonthPrice: 'other_month_price',
        cornerMark: 'corner_mark',
        confirmTips: 'confirm_tips',
        isActivity: 'is_activity',
        activitySkuId: 'activity_sku_id',
        activityVerifyMethod: 'activity_verify_method',
        activityPopupDisplayMethod: 'activity_popup_display_method',
        activityPopupImg: 'activity_popup_img',
        jumpUrl: 'jump_url',
        renewalSwitch: 'renewal_switch',
        renewalPrice: 'renewal_price',
        userChannelIds: 'user_channel_ids',
        aesKey: 'aes_key',
        standardSkuId: 'standard_sku_id',
        identityType: 'identity_type',
        shopCouponOrder: 'shop_coupon_order',
        rechargeLink: 'recharge_link',
        isSpecial: 'is_special',
        isMaoyan: 'is_maoyan',
        customPhoneList: 'custom_phone_list',
    };
    return transObjKey(res, keyMap);
}
